module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-800-4aa41e9e42589a211fdb09abcc3d12fa.jpg";